import { FocusMonitor } from "@angular/cdk/a11y";
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewEncapsulation,
} from "@angular/core";
import { MyqqButton } from "./button.component";

@Component({
  selector: `a[myqq-button]`,
  exportAs: "myqqButton, myqqAnchor",
  // tslint:disable-next-line: no-host-metadata-property
  host: {
    // Note that we ignore the user-specified tabindex when it's disabled for
    // consistency with the `myqq-button` applied on native buttons where even
    // though they have an index, they're not tabbable.
    "[attr.tabindex]": "disabled ? -1 : (tabIndex || 0)",
    "[attr.disabled]": "disabled || null",
    "[attr.aria-disabled]": "disabled.toString()",
    "(click)": "_haltDisabledEvents($event)",
    "[class.myqq-button-disabled]": "disabled",
    class: "myqq-button myqq-anchor",
  },
  // tslint:disable-next-line: no-inputs-metadata-property
  inputs: ["disabled", "color"],
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"],
  // tslint:disable-next-line: use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
// tslint:disable-next-line: component-class-suffix
export class MyqqAnchor extends MyqqButton {
  /** Tabindex of the button. */
  @Input() tabIndex: number;

  constructor(elementRef: ElementRef, focusMonitor: FocusMonitor) {
    super(elementRef, focusMonitor);
  }

  _haltDisabledEvents(event: Event) {
    // A disabled button shouldn't apply any actions
    if (this.disabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
}
